import { Navigate } from 'react-router-dom';
import { useSubscription } from '@/contexts/billing/subscription';
import { useRole } from '@/hooks/auth';
import { SetupAnalysisResult } from '@/types/agent/setup';
import { SetupPhase } from '@/hooks/agent/useGenieSetupReducer';
import { ParameterConfirmation, SuccessScreen } from './components';

interface ConfirmationViewProps {
  setupPhase: SetupPhase;
  analysisResult: SetupAnalysisResult | null;
  isCreatingGenie: boolean;
  createdAgent: any | null;
  createGenieFromAnalysis: (analysis: SetupAnalysisResult) => Promise<void>;
  resetSetup: () => void;
}

export const ConfirmationView = ({
  setupPhase,
  analysisResult,
  isCreatingGenie,
  createdAgent,
  createGenieFromAnalysis,
  resetSetup,
}: ConfirmationViewProps) => {
  const { isSubscribed } = useSubscription();
  const { isInternalAdmin } = useRole();

  if (setupPhase === "complete") {
    if (isSubscribed || isInternalAdmin()) {
      return (
        <div className="w-full h-full p-4 sm:p-6 overflow-y-auto flex items-center justify-center">
          <div className="w-full max-w-lg">
            <SuccessScreen
              createdAgent={createdAgent}
              onCreateAnother={resetSetup}
              onViewGenies={() => (window.location.href = "/genie-hub/my-genies")}
            />
          </div>
        </div>
      );
    }

    return <Navigate to="/genie-hub/my-genies" replace />;
  }

  if (setupPhase === "confirmation" && analysisResult) {
    return (
      <div className="w-full h-full p-4 sm:p-6 overflow-y-auto">
        <ParameterConfirmation
          analysis={analysisResult}
          onConfirm={createGenieFromAnalysis}
          onCancel={resetSetup}
          isCreating={isCreatingGenie}
        />
      </div>
    );
  }

  return null;
};
